import api from './api';

export const hsError = error => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (typeof detail?.message === 'string') {
    const labels = { birth_province: 'provincia di nascita', birth_date: 'data di nascita', document_number: 'numero documento', citizenship: 'cittadinanza' };
    const missing = Array.isArray(detail.missing_fields) ? detail.missing_fields.filter(x => typeof x === 'string').map(key => labels[key] || key.replaceAll('_', ' ')) : [];
    return detail.message + (missing.length ? ' Campi: ' + missing.join(', ') + '.' : '');
  }
  if (Array.isArray(detail)) return detail.map(item => item.msg).filter(Boolean).join('. ');
  return 'Operazione non riuscita. Aggiorna e riprova.';
};

export const collaboratorApi = {
  list: () => api.get('/home-smart/collaborators'),
  create: data => api.post('/home-smart/collaborators', data, { skipRetry: true, timeout: 90000 }),
  edit: (id, data) => api.put(`/home-smart/collaborators/${id}`, data, { skipRetry: true }),
  invite: id => api.post(`/home-smart/collaborators/${id}/invite`, {}, { skipRetry: true, timeout: 90000 }),
  assignProperty: (propertyId, data) => api.put(`/home-smart/properties/${propertyId}/collaborator`, data, { skipRetry: true }),
};